import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { Region } from "@/utils/regionApi";

interface OrganisationSlice {
  orgId?: number;
  region?: Region;
  shownCreditWarning: boolean;
  isOutOfCredits: boolean;
}

const initialState: OrganisationSlice = {
  orgId: undefined,
  region: undefined,
  shownCreditWarning: true,
  isOutOfCredits: false
} satisfies OrganisationSlice;

const organisationSlice = createSlice({
  name: "organisation",
  initialState,
  reducers: {
    setOrgId(state, action: PayloadAction<number>) {
      state.orgId = action.payload;
    },
    setRegion(state, action: PayloadAction<Region>) {
      state.region = action.payload;
    },
    setShownCreditWarning(state, action: PayloadAction<boolean>) {
      state.shownCreditWarning = action.payload;
    },
    setIsOutOfCredits(state, action: PayloadAction<boolean>) {
      state.isOutOfCredits = action.payload;
    }
  },
  selectors: {
    selectOrgId(state) {
      return state.orgId;
    },
    selectRegion(state) {
      return state.region;
    },
    selectShownCreditWarning(state) {
      return state.shownCreditWarning;
    },
    selectIsOutOfCredits(state) {
      return state.isOutOfCredits;
    }
  }
});

export const { setOrgId, setRegion, setShownCreditWarning, setIsOutOfCredits } = organisationSlice.actions;
export const { selectOrgId, selectRegion, selectShownCreditWarning, selectIsOutOfCredits } = organisationSlice.selectors;
export default organisationSlice.reducer;
